import moment from "moment-timezone";
import Config from "../models/config";

export function convertDate(object: any): Date | null {
    if (typeof object === "string" || typeof object === "number") {
        return new Date(object);
    } else if (typeof object === "object") {
        return object as Date;
    }
    return null;
}

export const getTimeFixBug = (value: any) => {
    if (typeof value === "string" && typeof value === "number") {
        return new Date(value).getTime();
    }
    return value?.getTime();
};

export const getLocalDateTimeFixBug = (value: any) => {
    if (typeof value === "string" && typeof value === "number") {
        return new Date(value).toLocaleDateString();
    }
    return value?.toLocaleDateString();
};

export const formatDate = (date: Date, format = "default") => {
    if (!date) {
        return "";
    }
    let year: any = moment(date).tz(Config.TIMEZONE).year();
    let months: any = moment(date).tz(Config.TIMEZONE).month() + 1;
    let day: any = moment(date).tz(Config.TIMEZONE).date();
    var stringTime = "";
    var stringMonths = "";
    var stringDay = "";
    if (months < 10) {
        stringMonths = "0" + months.toString();
    } else {
        stringMonths = months.toString();
    }
    if (day < 10) {
        stringDay = "0" + day.toString();
    } else {
        stringDay = day.toString();
    }
    if (format === "dd/mm/yyyy") {
        stringTime = stringDay + "/" + stringMonths + "/" + year;
    } else if (format === "yyyy/mm/dd") {
        stringTime = year + "/" + stringMonths + "/" + stringDay;
    } else {
        stringTime = year + "-" + stringMonths + "-" + stringDay;
    }
    return stringTime;
};
